module.exports = __webpack_public_path__ + "img/hero-07.d4763648.jpg";